export const CourseState = {
  UNAVAILABLE: "UNAVAILABLE",
  NOT_STARTED: "NOT_STARTED",
  ONGOING: "ONGOING",
  READY_TO_FINISH: "READY_TO_FINISH",
  COMPLETED: "COMPLETED",
  COMPLETED_FAIL: "COMPLETED_FAIL",
}

type Keys = keyof typeof CourseState
export type CourseStates = typeof CourseState[Keys]
